// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.login .oc-login-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
}

.login .oc-login-box {
  width: 100%;
  max-width: 420px;
  padding: 32px 28px 28px;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18);
}

.login .oc-login-header {
  margin-bottom: 24px;
}

.login .oc-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.login .oc-brand img {
  border-radius: 999px;
}

.login .oc-login-title {
  margin-top: 8px;
  font-size: 14px;
  color: #6b7280;
}

.login .oc-login-form .form-group {
  margin-bottom: 16px;
}

.login .oc-login-form label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
}

.login .oc-input-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-radius: 9px;
  border: 1px solid #d1d5db;
  background: #f9fafb;
}

.login .oc-input-icon .icon {
  font-size: 16px;
  color: #9ca3af;
}

.login .oc-input {
  flex: 1 1;
  height: 42px;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
  color: #111827;
}

.login .oc-input::placeholder {
  color: #9ca3af;
}

.login .oc-login-actions {
  margin-top: 8px;
}

.login .oc-btn.primary {
  width: 100%;
  height: 44px;
  border-radius: 999px;
  border: none;
  font-size: 15px;
  font-weight: 600;
  background: #2563eb;
  color: #ffffff;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.05s ease, box-shadow 0.15s ease;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.35);
}

.login .oc-btn.primary:disabled {
  opacity: 0.75;
  cursor: default;
  box-shadow: none;
}

.login .oc-btn.primary:not(:disabled):hover {
  background: #1d4ed8;
}

.login .oc-btn.primary:not(:disabled):active {
  transform: translateY(1px);
  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.4);
}

.login .oc-alert-error {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 9px;
  font-size: 13px;
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Auth/css/LoginPage.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,iFAAiF;AACnF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,8EAA8E;EAC9E,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["html,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n.login .oc-login-wrapper {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f4f6;\n}\n\n.login .oc-login-box {\n  width: 100%;\n  max-width: 420px;\n  padding: 32px 28px 28px;\n  border-radius: 14px;\n  background: #ffffff;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.18);\n}\n\n.login .oc-login-header {\n  margin-bottom: 24px;\n}\n\n.login .oc-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.login .oc-brand img {\n  border-radius: 999px;\n}\n\n.login .oc-login-title {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.login .oc-login-form .form-group {\n  margin-bottom: 16px;\n}\n\n.login .oc-login-form label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #4b5563;\n}\n\n.login .oc-input-icon {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border-radius: 9px;\n  border: 1px solid #d1d5db;\n  background: #f9fafb;\n}\n\n.login .oc-input-icon .icon {\n  font-size: 16px;\n  color: #9ca3af;\n}\n\n.login .oc-input {\n  flex: 1;\n  height: 42px;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  background: transparent;\n  color: #111827;\n}\n\n.login .oc-input::placeholder {\n  color: #9ca3af;\n}\n\n.login .oc-login-actions {\n  margin-top: 8px;\n}\n\n.login .oc-btn.primary {\n  width: 100%;\n  height: 44px;\n  border-radius: 999px;\n  border: none;\n  font-size: 15px;\n  font-weight: 600;\n  background: #2563eb;\n  color: #ffffff;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.05s ease, box-shadow 0.15s ease;\n  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.35);\n}\n\n.login .oc-btn.primary:disabled {\n  opacity: 0.75;\n  cursor: default;\n  box-shadow: none;\n}\n\n.login .oc-btn.primary:not(:disabled):hover {\n  background: #1d4ed8;\n}\n\n.login .oc-btn.primary:not(:disabled):active {\n  transform: translateY(1px);\n  box-shadow: 0 6px 14px rgba(37, 99, 235, 0.4);\n}\n\n.login .oc-alert-error {\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  border-radius: 9px;\n  font-size: 13px;\n  background: #fee2e2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
